const PUBLIC_ROUTES = new Set(['/login'])

export default defineNuxtRouteMiddleware(async (to) => {
  // Les pages publiques ne necessitent pas d'authentification
  if (PUBLIC_ROUTES.has(to.path)) {
    return
  }

  const store = useAuthStore()

  // Charger la session si pas encore fait
  if (store.loading && !store.authenticated) {
    await store.fetchSession()
  }

  // Rediriger vers login si non authentifie
  if (!store.authenticated) {
    // Sanitize : ne garder que les paths internes pour redirect_after
    const redirectAfter = to.fullPath.startsWith('/') && !to.fullPath.startsWith('//') ? to.fullPath : '/'

    return navigateTo({
      path: '/login',
      query: { redirect_after: redirectAfter },
    })
  }
})
